<template lang="pug">
div#tl-app(
    :class="{ dark: dark }"
)
    div#tl-portal
    slot
</template>

<script lang="ts" setup>
import { provide, computed, ref, onMounted } from 'vue'
import { useDarkMode } from '@/composables/ui/useDarkMode'

const props = defineProps({
    dark: Boolean,
    light: Boolean,
})

const { checkUserMode } = useDarkMode()

const userDarkMode = ref(false)
const dark = computed(() => (props.dark || userDarkMode.value) && !props.light)

onMounted(() => {
    userDarkMode.value = checkUserMode()
})

provide('dark', dark)
</script>

<style lang="sass" scoped>
#tl-app
    transition: all .2s
    min-height: 100vh
    background-color: var(--color-white)
    display: block
    position: relative
    &.darkmode
        background-color: rgba(0,0,0,0.9)
</style>
